module.exports = __webpack_public_path__ + "r-v3/img/ico_radio_not_checked.ad6ff8db.svg";